module.exports = __webpack_public_path__ + "static/desktop/img/calendar-1-thumb.684e65bd.png";